//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WeekQualityControlModal from "./modules/WeekQualityControlModal";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
import { getAction, postAction } from '@api/manage'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'WeekQualityControlList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    WeekQualityControlModal: WeekQualityControlModal
  },
  data: function data() {
    return {
      pagePath: '/om/week/quality/control',
      pageTitle: '周质控设置',
      factorModelList: [],
      queryDataList: [],
      siteId: '',
      current: 1,
      pageSize: 10,
      factorCode: '',
      addDisabled: false,
      url: {
        queryFactorModel: '/om/week/quality/control/queryFactorModel/',
        queryHistoryList: '/om/week/quality/control/detectionFactor/'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'monitorProject_dictText',
        colName: 'monitor_project',
        title: '监测项目',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'standardConcentration',
        colName: 'standard_concentration',
        title: '设置标准溶液浓度',
        align: 'center',
        sorter: false,
        customRender: function customRender(t, r, index) {
          return t ? t + ' ' + r.unitName : 0 + ' ' + r.unitName;
        }
      }, {
        dataIndex: 'commitTime',
        colName: 'commit_time',
        title: '提交时间',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '提交人',
        align: 'center',
        sorter: false
      }, // {
      //     dataIndex: 'reviewedBy',
      //     colName: 'reviewed_by',
      //     title: '审核人',
      //     align: "center",
      //     sorter: false
      // },
      // {
      //     dataIndex: 'reviewedTime',
      //     colName: 'reviewed_time',
      //     title: '审核时间',
      //     align: "center",
      //     sorter: false
      // },
      // {
      //     dataIndex: 'status',
      //     colName: 'status',
      //     title: '是否过期',
      //     align: "center",
      //     sorter: false
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 150,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  //站点树监视
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.siteId = this.queryParam.siteId;
        this.spliceColumn(this.siteColumn); //查询站点

        this.delayLoadData(); //加载匹配的站点因子

        this.loadFactorModel(this.siteId);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    handleDetail: function handleDetail(record) {
      var _this = this;

      getAction(this.url.queryHistoryList + record.monitorProject).then(function (res) {
        if (res.success) {
          var historyData = res.result;

          _this.$refs.modalForm.edit({
            historyData: historyData
          });

          _this.$refs.modalForm.title = _this.pageTitle + '-历史记录';
          _this.$refs.modalForm.disableSubmit = true;
          _this.$refs.modalForm.showTab = true;
          _this.$refs.modalForm.showContact = false;
          _this.$refs.modalForm.activeKey = '1';
          _this.$refs.modalForm.showInput = false;
        }
      });
    },
    handleAdd: function handleAdd() {
      // console.log(JSON.parse(JSON.stringify(this.queryDataList)))
      // this.loadFactorModel(this.siteId)
      this.$refs.modalForm.add(JSON.parse(JSON.stringify(this.queryDataList)));
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleChange: function handleChange(value) {
      this.factorCode = '';

      for (var i = 0; i < value.length; i++) {
        var part = value[i];
        this.factorCode = this.factorCode + ',' + part;
      }
    },
    onToSearch: function onToSearch() {
      var _this2 = this;

      var param = {
        pageNo: this.current,
        pageSize: this.pageSize,
        siteId: this.siteId,
        factorCode: this.factorCode
      };
      getAction(this.pagePath, param).then(function (res) {
        if (res.success) {
          _this2.dataSource = res.result == null ? null : res.result.records;
        }
      });
    },
    loadFactorModel: function loadFactorModel(siteId) {
      var that = this;
      that.factorModelList = [];
      getAction(this.url.queryFactorModel + siteId).then(function (res) {
        if (res.success) {
          that.factorModelList = res.result;
          that.queryDataList = [];

          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.queryDataList.push({
              title: temp.title,
              monitorProject: temp.code,
              siteId: siteId,
              unitName: temp.unitName,
              standardConcentration: '',
              certificateNum: '',
              standardValue: ''
            });
          }
        }
      });
    },
    onDateCommitTime: function onDateCommitTime(value, dateArray) {
      this.queryParam.commitTimeStart = dateArray[0];
      this.queryParam.commitTimeEnd = dateArray[1];
    },
    onDateReviewedTime: function onDateReviewedTime(value, dateArray) {
      this.queryParam.reviewedTimeStart = dateArray[0];
      this.queryParam.reviewedTimeEnd = dateArray[1];
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};